import { lazyLoadOnRender } from '@ms/yammer-libs-lazy';
import type { ComponentType } from 'react';

const LazyPushNotificationsDeprecationBanner = () =>
  import(
    /* webpackChunkName: "4-feat-push-notifications-deprecation-banner" */ './PushNotificationsDeprecationBanner'
  ).then((m) => ({ default: m.PushNotificationsDeprecationBanner }));

const LoadablePushNotificationsDeprecationBanner: ComponentType = lazyLoadOnRender({
  loader: LazyPushNotificationsDeprecationBanner,
});

// eslint-disable-next-line import-x/no-default-export
export default LoadablePushNotificationsDeprecationBanner;
